import { DeviceManifest } from '@rapoo/device-sdk'
import { baseChannel0To7, baseChildDeviceEnabled } from './generate/capabilityPresets'
import { p8BaseLightBandEffects } from './generate/lightingPresets'

/**
 * ESPR5 底座设备清单
 */
const rapooESPR5: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESPR5',
  mainControl: 'ESPR5',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x1445,
    currentPid: 0x1445,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 2,
        description: 'Base Nordic Firmware Update Interface',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Base WCH Firmware Update Interface',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'lighting',
  ui: {
    assetsDir: 'manifests/ESPR5',
    colors: {
      series: [
        {
          name: 'common.products.ESPR5.Raspberry_Pink',
          value: '#FF2558',
          key: 'Raspberry_Pink',
        },
        {
          name: 'common.products.ESPR5.Gray_Black_Red',
          value: '#2B2B2B',
          key: 'Gray_Black_Red',
        },
      ],
      current: 'Raspberry_Pink',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: p8BaseLightBandEffects,
      },
    },
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    image: 'devices/base/base.png',
    keys: [],
  },
}

export default rapooESPR5
